import { CountryProvinceSelector } from '@shopify/theme-addresses';
import { attachValidator, resetFormInputs } from '../../../react/utils/formValidator';
import { serialize, logout } from '../../../react/utils/accountUtils';
import { setUpReferral } from '../../utils/referral';
import { ajax } from '../../../react/utils/ajax';
// Address logic import
import './addresses.js';

const selectors = {
  customerAccount: '[data-customer-account]',
  addressContainer: '[data-address]',
  addressToggle: '[data-address-toggle]',
  addressCountry: '[data-address-country]',
  addressProvince: '[data-address-province]',
  addressProvinceWrapper: '[data-address-province-wrapper]',
  addressForm: '[data-address-form]',
  addressDeleteForm: '[data-address-delete-form]',
  addressNewForm: '[address-form-new]',
  passwordResetLink: '[password-reset-link]',
  resetSuccess: '[data-reset-success]',
  updatePasswordForm: '[data-update-password',
  logoutButton: '[logout-button]',
  recoverPasswordForm: '[data-recover-form]',
};

let userLoyaltyId = 0;

//setup behavior for side menu navigation
//switching between mobile and desktop layouts
//keeping browser history updated with hashs

function updateMobileHeader(type) {
  const subNavs = document.querySelector(selectors.customerAccount).querySelector('.mobile-header-sub-nav');

  subNavs.querySelectorAll('.mobile-header-sub-nav-title').forEach(function (el) {
    el.classList.remove('visible-item');
  });

  if (type && type.length > 0) {
    subNavs.querySelector('.customer-name').classList.add('hidden-item');
    subNavs.querySelector('div[data-section="' + type + '"]').classList.add('visible-item');
    subNavs.querySelector('.mobile-header-sub-nav-link').classList.add('visible-item');
  } else {
    subNavs.querySelector('.customer-name').classList.remove('hidden-item');
    subNavs.querySelector('.mobile-header-sub-nav-link').classList.remove('visible-item');
  }
}

function updateLayoutContentHeight(type) {
  const sections = document.querySelector(selectors.customerAccount).querySelector('.account-sections');
  const section = sections.querySelector('div[data-section="' + type + '"]');

  document.querySelector(selectors.customerAccount).querySelector('.account-content').style.height =
    section.offsetHeight + 'px';
}

function showSection(type) {
  if (window.innerWidth < 480) {
    const customerLogout = document.getElementById('customer-logout-account');
    customerLogout.style.display = 'none';
  }
  document
    .querySelector(selectors.customerAccount)
    .querySelectorAll('.account-section')
    .forEach(function (el) {
      el.classList.remove('visible');
    });

  const sections = document.querySelector(selectors.customerAccount).querySelector('.account-sections');
  const section = sections.querySelector('div[data-section="' + type + '"]');
  section.classList.add('visible');
  sections.classList.add('slide-in');
  updateLayoutContentHeight(type);
}

function updateSideNavigation(type) {
  const navItems = document.querySelector(selectors.customerAccount).querySelector('.account-navigation');
  const navItem = navItems.querySelector('div[data-section="' + type + '"]');
  const prevItem = navItems.querySelector('.menu-item-selected');
  prevItem && prevItem.classList.remove('menu-item-selected');
  navItem && navItem.classList.add('menu-item-selected');
}

function loadSection(type) {
  showSection(type);
  updateMobileHeader(type);
  updateSideNavigation(type);
}

function accountMenuClickHandler(e) {
  e.preventDefault();
  const type = e.target.getAttribute('data-section');
  loadSection(type);
  updateUrlHash(type);
}

function updateUrlHash(type) {
  let hash;
  if (type === 'shipping-info') {
    hash = '#shipping';
  } else if (type === 'orders-info') {
    hash = '#orders';
  } else if (type === 'rewards-info') {
    hash = '#rewards';
  } else {
    hash = window.location.href.replace(/#.*$/, '');
  }
  window.history.replaceState('', document.title, hash);
}

function updateBirthdayDays() {
  const possibleDatesHidden = ['29', '30', '31'];
  const datesToHide = {
    2: ['29', '30', '31'],
    4: ['31'],
    6: ['31'],
    9: ['31'],
    11: ['31'],
  };

  possibleDatesHidden.forEach((val, i) => {
    if (document.getElementById('birthday-day').querySelector("option[value='" + val + "']")) {
      document.getElementById('birthday-day').querySelector("option[value='" + val + "']").style.display = 'block';
    }
  });

  const monthSelectElem = document.getElementById('birthday-month');
  if (monthSelectElem) {
    for (const [key, value] of Object.entries(datesToHide)) {
      if (key == monthSelectElem.value) {
        for (let i = 0; i < value.length; i++) {
          document.getElementById('birthday-day').querySelector("option[value='" + value[i] + "']").style.display =
            'none';
        }
      }
    }
  }
}

function checkUrlHash() {
  const hash = window.location.hash;
  if (hash === '#shipping') {
    loadSection('shipping-info');
  } else if (hash === '#orders') {
    loadSection('orders-info');
  } else {
    const screen = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    if (screen >= 1024) {
      loadSection('account-info');
    }
  }
}

function mobileBackHandler(e) {
  e.preventDefault();
  if (window.innerWidth < 480) {
    const customerLogout = document.getElementById('customer-logout-account');
    customerLogout.style.display = 'block';
  }
  document.querySelector(selectors.customerAccount).querySelector('.account-sections').classList.remove('slide-in');

  document.querySelector(selectors.customerAccount).querySelector('.account-content').style.height = 'auto';

  document.querySelectorAll('.menu-item').forEach(function (item) {
    item.classList.remove('menu-item-selected');
  });

  setTimeout(function () {
    document
      .querySelector(selectors.customerAccount)
      .querySelectorAll('.account-section')
      .forEach(function (el) {
        el.classList.remove('visible');
      });
    updateMobileHeader('');
    const nohash = window.location.href.replace(/#.*$/, '');
    window.history.replaceState('', document.title, nohash);
  }, 200);
}

//handle init event for address plugin
//attach validation for all address form input fields

function closeEditAddressForm(addressForm) {
  addressForm.classList.toggle('hide');
  if (addressForm.classList.contains('new-address-form')) {
    resetFormInputs(addressForm);
    document.querySelector('.toggle-new-address-form').classList.remove('hide');
  }
  updateLayoutContentHeight('shipping-info');
}

function initializeAddressForm(countryProvinceSelector, container) {
  const countrySelector = container.querySelector(selectors.addressCountry);
  const provinceSelector = container.querySelector(selectors.addressProvince);
  const provinceWrapper = container.querySelector(selectors.addressProvinceWrapper);
  const addressForm = container.querySelector(selectors.addressForm);

  countryProvinceSelector.build(countrySelector, provinceSelector, {
    onCountryChange: (provinces) => {
      countrySelector.parentNode.querySelector('label').classList.add('hide');
      provinceWrapper.classList.toggle('hide', !provinces.length);
    },
  });

  addressForm.querySelectorAll(selectors.addressToggle).forEach((button) => {
    button.addEventListener('click', (e) => {
      e.preventDefault();
      closeEditAddressForm(addressForm);
    });
    button.addEventListener('touchstart', (e) => {
      e.preventDefault();
      closeEditAddressForm(addressForm);
    });
  });

  addressForm.querySelectorAll('input[data-rule]').forEach((trigger) => {
    attachValidator(trigger);
  });
}

//handle toggle click on edit address form
function showEditAddressForm(e) {
  e.preventDefault();
  const toggleId = e.currentTarget.getAttribute('data-edit');

  if (toggleId) {
    document.querySelectorAll(selectors.addressForm).forEach(function (form) {
      form.classList.add('hide');
      if (toggleId === form.getAttribute('data-default')) {
        form.classList.toggle('hide');

        const screen = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        if (screen < 1024) {
          const scroll = form.classList.contains('hide') ? false : true;
          if (scroll) {
            form.scrollIntoView();
          }
        }
      }
    });
  }

  if (toggleId === 'new-address') {
    e.currentTarget.classList.toggle('hide');
  }
  updateLayoutContentHeight('shipping-info');
}

//hadle delete submit request of user's address box
function handleDeleteAddress(e) {
  e.preventDefault();

  const id = e.target.getAttribute('data-address-id');
  const deleteUrl = '/account/addresses/' + id;
  const url = window.location.protocol + '//' + window.location.host + '/account#shipping';

  const form = this;
  const serialized = serialize(e.target);

  ajax.post(deleteUrl, serialized, function (response) {
    var html = document.createDocumentFragment();
    var div = document.createElement('div');

    div.innerHTML = response;
    html.appendChild(div);

    const errorStr = html.querySelector('#address_form_new .errors');
    if (errorStr) html.textContent.replace(/\s/g, '');

    if (errorStr) {
      document.querySelector('.error-request-modal').classList.remove('hide');
    } else {
      location.reload(true);
    }
  });
}

//handle edit address form submit event
function editAddressFormHandler(e) {
  e.preventDefault();

  const url = window.location.protocol + '//' + window.location.host + '/account#shipping';

  const form = this.querySelector('form');
  const serialized = serialize(form);
  const attrs = form.getAttribute('id').split('_');

  ajax.post('/account/addresses/' + attrs[attrs.length - 1], serialized, function (response) {
    var html = document.createDocumentFragment();
    var div = document.createElement('div');

    div.innerHTML = response;
    html.appendChild(div);

    const errorStr = html.querySelector('.errors');
    if (errorStr) html.textContent.replace(/\s/g, '');

    if (errorStr) {
      document.querySelector('.error-request-modal').classList.remove('hide');
    } else {
      location.reload(true);
    }
  });
}

//hadle submit event on new address form
function handleNewAddressSubmit(e) {
  e.preventDefault();
  const url = window.location.protocol + '//' + window.location.host + '/account#shipping';

  const form = this;
  const serialized = serialize(form);

  ajax.post('/account/addresses', serialized, function (response) {
    var html = document.createDocumentFragment();
    var div = document.createElement('div');

    div.innerHTML = response;
    html.appendChild(div);

    const errorStr = html.querySelector('.errors');
    if (errorStr) html.textContent.replace(/\s/g, '');

    if (errorStr) {
      document.querySelector('.error-request-modal').classList.remove('hide');
    } else {
      location.reload(true);
    }
  });
}

//handle reset password link click event
function resetPasswordLinkHandler(e) {
  e.preventDefault();

  if (this.getAttribute('data-email')) {
    const form = document.createElement('FORM');
    const input = document.createElement('INPUT');
    input.setAttribute('name', 'form_type');
    input.setAttribute('value', 'reset_customer_password');
    const inputEmail = document.createElement('INPUT');
    inputEmail.setAttribute('name', 'email');
    inputEmail.setAttribute('value', this.getAttribute('data-email'));

    form.appendChild(input);
    form.appendChild(inputEmail);

    const serialized = serialize(form);

    ajax.post('/account/recover', serialized, function (response) {
      var html = document.createDocumentFragment();
      var div = document.createElement('div');

      div.innerHTML = response;
      html.appendChild(div);
      const errors = html.querySelector('.errors');

      if (errors) {
        document.querySelector(selectors.recoverPasswordForm).querySelector('.errors-output .errors') &&
          document.querySelector(selectors.recoverPasswordForm).querySelector('.errors-output .errors').remove();

        document.querySelector(selectors.recoverPasswordForm).querySelector('.errors-output').appendChild(errors);
      } else {
        document.querySelector(selectors.resetSuccess).classList.remove('hide');
      }
    });
  }
}

//handle user user logout
function logoutUserHandler(e) {
  e.preventDefault();
  logout();
}

function userAccountInit() {
  //attach events to logout buttons
  if (document.querySelector(selectors.logoutButton)) {
    document.querySelectorAll(selectors.logoutButton).forEach((trigger) => {
      trigger.addEventListener('click', logoutUserHandler);
      trigger.addEventListener('touchstart', logoutUserHandler);
    });
  }

  //attach click to send a reset password link
  if (document.querySelector(selectors.passwordResetLink)) {
    document.querySelector(selectors.passwordResetLink).addEventListener('click', resetPasswordLinkHandler);
  }

  //attach submit for new address form
  if (document.getElementById('address_form_new')) {
    document.getElementById('address_form_new').addEventListener('submit', handleNewAddressSubmit);
  }

  //attach click event to delete user address box
  if (document.querySelector(selectors.addressDeleteForm)) {
    document.querySelectorAll(selectors.addressDeleteForm).forEach((trigger) => {
      trigger.addEventListener('submit', handleDeleteAddress);
    });
  }

  //attach toggle click event for edit address form
  if (document.querySelector(selectors.addressToggle)) {
    document.querySelectorAll(selectors.addressToggle).forEach((trigger) => {
      trigger.addEventListener('click', showEditAddressForm);
    });
  }

  //edit address form submit handle
  if (document.querySelector(selectors.addressForm)) {
    document.querySelectorAll(selectors.addressForm).forEach((form) => {
      form.addEventListener('submit', editAddressFormHandler);
    });
  }

  //initialize address plugin for all address forms
  if (document.querySelectorAll(selectors.addressContainer)) {
    const countryProvinceSelector = new CountryProvinceSelector(window.theme.allCountryOptionTags);

    document.querySelectorAll(selectors.addressContainer).forEach((addressContainer) => {
      initializeAddressForm(countryProvinceSelector, addressContainer);
    });
  }

  //assigned all events related to side navigation (mobile and desktop)
  if (document.querySelector(selectors.customerAccount)) {
    const customerAccount = document.querySelector(selectors.customerAccount);

    customerAccount.querySelectorAll('.account-navigation .menu-item').forEach((trigger) => {
      trigger.addEventListener('click', accountMenuClickHandler);
      trigger.addEventListener('touchstart', accountMenuClickHandler);
    });

    customerAccount.querySelectorAll('.mobile-header-sub-nav-link').forEach((trigger) => {
      trigger.addEventListener('click', mobileBackHandler);
      trigger.addEventListener('touchstart', mobileBackHandler);
    });

    window.addEventListener('load', function () {
      checkUrlHash();
    });
  }

  document.querySelectorAll("INPUT[type='checkbox']").forEach(function (radio) {
    radio.addEventListener('click', function (e) {
      if (!e.currentTarget.getAttribute('checked')) {
        e.currentTarget.setAttribute('checked', 'checked');
        e.currentTarget.classList.add('checked');
        e.currentTarget.checked = true;
      } else {
        e.currentTarget.setAttribute('checked', '');
        e.currentTarget.classList.remove('checked');
        e.currentTarget.checked = false;
      }
    });
  });
}

function updateLoyaltyAccount(myData, fetchUrl, guid, apiKey) {
  fetch('https://loyalty.yotpo.com/api/v2/' + fetchUrl + '?guid=' + guid + '&api_key=' + apiKey, {
    method: 'POST',
    body: JSON.stringify(myData),
    headers: {
      'content-type': 'application/json; charset=utf-8',
    },
  })
    .then(function (response) {
      if (response.ok) {
        return response.json();
      }
      return Promise.reject(response);
    })
    .catch(function (error) {
      console.warn('Something went wrong.', error);
    });
}

function checkLoyaltyAccount(guid, apiKey, customerEmail, updatePage) {
  fetch(
    'https://loyalty.yotpo.com/api/v2/customers?guid=' +
      guid +
      '&api_key=' +
      apiKey +
      '&customer_email=' +
      customerEmail,
    {
      method: 'GET',
      headers: {
        'content-type': 'application/json; charset=utf-8',
      },
    }
  )
    .then(function (response) {
      if (response.ok) {
        return response.json();
      }
      return Promise.reject(response);
    })
    .then(function (data) {
      updatePage(data);
    })
    .catch(function (error) {
      console.warn('Something went wrong.', error);
      return false;
    });
}

function submitNameChange(guid, apiKey) {
  const firstName = document.getElementById('CustomerFirstName');
  const lastName = document.getElementById('CustomerLastName');
  const customerEmail = document.getElementById('customer-current-email').innerText;
  const welcomeTextMobile = document.getElementById('welcome-customer-text-mobile');
  const welcomeText = document.getElementById('welcome-customer-text');

  if (firstName && lastName) {
    let myData = {
      first_name: firstName.value,
      last_name: lastName.value,
      email: customerEmail,
      id: userLoyaltyId.toString(),
    };

    if (firstName.value) welcomeText.innerText = 'Hi, ' + firstName.value;
    if (firstName.value) welcomeTextMobile.innerText = 'Hi, ' + firstName.value;
    updateLoyaltyAccount(myData, 'customers', guid, apiKey);
  }
}

function submitBirthday(guid, apiKey) {
  //get month, day
  const monthSelect = document.getElementById('birthday-month');
  const daySelect = document.getElementById('birthday-day');
  const customerEmail = document.getElementById('customer-current-email').innerText;

  if (monthSelect && daySelect) {
    let myData = {
      customer_email: customerEmail,
      day: daySelect.value,
      month: monthSelect.value,
    };

    updateLoyaltyAccount(myData, 'customer_birthdays', guid, apiKey);
    monthSelect.style.cssText = 'pointer-events: none; background-color: #E6E6E6';
    daySelect.style.cssText = 'pointer-events: none; background-color: #E6E6E6';
  }
}

function checkIfBirthdayExists(guid, apiKey) {
  const customerEmail = document.getElementById('customer-current-email').innerText;
  const monthSelect = document.getElementById('birthday-month');
  const daySelect = document.getElementById('birthday-day');
  const birthdayHeaderText = document.getElementById('birthday-header-text');
  const currentRewards = document.getElementById('currentRewards');
  const firstName = document.getElementById('CustomerFirstName');
  const lastName = document.getElementById('CustomerLastName');
  const welcomeTextMobile = document.getElementById('welcome-customer-text-mobile');
  const welcomeText = document.getElementById('welcome-customer-text');

  const updateBirthdayIfExists = (data) => {
    userLoyaltyId = data.third_party_id;
    if (data.first_name) firstName.value = data.first_name;
    if (data.last_name) lastName.value = data.last_name;
    if (data.first_name) welcomeText.innerText = 'Hi, ' + data.first_name;
    if (data.first_name) welcomeTextMobile.innerText = 'Hi, ' + data.first_name;
    if (currentRewards) {
      let currPts = data.credit_balance_in_customer_currency;
      currentRewards.innerText = currPts;
    }
    if (data.birth_day && data.birthday_month) {
      monthSelect.value = data.birthday_month;
      daySelect.value = data.birth_day;
      monthSelect.style.cssText = 'pointer-events: none; background-color: #E6E6E6';
      daySelect.style.cssText = 'pointer-events: none; background-color: #E6E6E6';
      birthdayHeaderText.innerText = 'BIRTHDAY';
      return true;
    } else {
      return false;
    }
  };

  checkLoyaltyAccount(guid, apiKey, customerEmail, updateBirthdayIfExists);
}

function getCurrentRewards(customerEmail, guid, apiKey) {
  const dateElem = document.getElementById('member-since-date');
  const ptsRedeemed = document.getElementById('ptsRedeemed');
  const ptsTotal = document.getElementById('ptsTotal');
  const currentRewards = document.getElementById('currentRewards');

  const updateCurrentRewards = (data) => {
    if (dateElem) {
      let dateArr = data.opted_in_at.split('-');
      let monthInt = parseInt(dateArr[1]);
      const optInAt = new Date(dateArr[0], monthInt - 1, dateArr[2]);
      let dateString = optInAt.toLocaleString('en-US', { dateStyle: 'full' });
      let onlyMonth = dateString.split(', ');
      dateElem.innerText = onlyMonth[1] + ', ' + onlyMonth[2];
    }
    if (ptsRedeemed) {
      var totalPts = data.points_earned - data.points_balance;
      ptsRedeemed.innerText = totalPts;
    }
    if (ptsTotal) {
      ptsTotal.innerText = data.points_balance;
    }
    if (currentRewards) {
      currentRewards.innerText = data.credit_balance_in_customer_currency;
    }
  };

  checkLoyaltyAccount(guid, apiKey, customerEmail, updateCurrentRewards);
}

document.addEventListener('DOMContentLoaded', function () {
  const guidMap = {
    'en-US': 'Vs-Ipq7otwfAaQYVmUc2og',
    'en-GB': 'cs0a_H5qvhF3EGBqTIrYzA',
    dev: 'aqld7PCs5se8o1I2mGUp1g',
  };
  const apiMap = {
    'en-US': 'URYYEyHLjovHbvKjOc2LDAtt',
    'en-GB': 'vJFQCMEChCC0USnyhb8NtQtt',
    dev: 'CkPAQOEQhCM33gCR0TnhGQtt',
  };
  const guid =
    window.location.href && window.location.href.includes('dev') ? guidMap[dev] : guidMap[window.geoLocale.location];
  const apiKey =
    window.location.href && window.location.href.includes('dev') ? apiMap[dev] : apiMap[window.geoLocale.location];

  const customerEmail = document.getElementById('customer-current-email').innerText;
  const birthdaySelectElem = document.getElementById('birthday-month');
  const saveChangesButton = document.getElementById('save-changes-button');
  const updatedAccountText = document.getElementById('updated-account-text');
  const rewardTabMobile = document.getElementById('reward-tab-mobile');
  const rewardTabDesktop = document.getElementById('reward-tab-desktop');

  const birthdayExists = checkIfBirthdayExists(guid, apiKey);

  const userFullName = document.querySelector('.full-name-container');

  if (userFullName && window.location.href.includes('ruggable.co.uk')) {
    userFullName.style.pointerEvents = 'none';
  }

  userAccountInit();
  setUpReferral();
  getCurrentRewards(customerEmail, guid, apiKey);

  if (rewardTabMobile) {
    rewardTabMobile.addEventListener('click', () => getCurrentRewards(customerEmail, guid, apiKey));
  }
  if (rewardTabDesktop) {
    rewardTabDesktop.addEventListener('click', () => getCurrentRewards(customerEmail, guid, apiKey));
  }

  if (birthdaySelectElem) {
    birthdaySelectElem.addEventListener('change', function () {
      updateBirthdayDays();
    });
  }

  //check if birthday already exists
  if (saveChangesButton) {
    if (!birthdayExists) {
      saveChangesButton.addEventListener('click', function () {
        submitBirthday(guid, apiKey);
        submitNameChange(guid, apiKey);
        updatedAccountText.style.display = 'block';
      });
    } else {
      saveChangesButton.addEventListener('click', function () {
        submitNameChange(guid, apiKey);
        updatedAccountText.style.display = 'block';
      });
    }
  }
});
